import "./src/styles/global.css";
// gatsby-browser.js
import React from 'react';
import { QueryProvider } from './src/components/providers/QueryProvider';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './src/theme';

export const wrapRootElement = ({ element }) => {
  return (
    <ChakraProvider theme={theme}>
      <QueryProvider>{element}</QueryProvider>
    </ChakraProvider>
  );
};